var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Actor } from './Actor';
import { editable, editObservable } from '../../utils/mobx/decorators/editable';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { runtime } from '../runtime/Runtime';
export class PersistActor extends Actor {
    database_serialized;
    isDatabaseEntity = true;
    constructor(init) {
        super(init);
        editObservable(this);
    }
    get persistSync() {
        return new runtime.solidPackages.Edit.classes.PersistSync(this);
    }
    get isWriteEnabled() {
        return !!this.context.user && this.context.user.userPermissions.shouldSaveEditEntities;
    }
}
__decorate([
    editable('ref')
], PersistActor.prototype, "database_serialized", void 0);
__decorate([
    memoize
], PersistActor.prototype, "persistSync", null);
